import styled from '@emotion/styled';

export const TileTitle = styled.span`
    color: white;
    font-size: 10px;
    font-weight: 500;
    line-height: 12px;

    position: absolute;
    z-index: 10;
    top: 4px;
    left: 4px;

    visibility: hidden;
`;
